module.exports = __webpack_public_path__ + "img/iconli.df700069.png";